<template>
    <controller>
        <page-header title="Negocie Já - Formas de Pagamento"> 
            <template v-slot:side>
                <button class="btn btn-primary" @click.stop.prevent="abrirModalNovoPagamento(i)">
                    Criar
                </button>
            </template>
        </page-header>
        <main class="main-page">
          <header class="header-page">
            <h4>Resultado de Formas de Pagamento</h4>
            <input-control placeholder="Buscar por nome..." search preventSearchButton ></input-control>
          </header>
          <section class="table-body">
            <table class="transparent-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th class="text-right">Editar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in formasPagamento" :key="item.idNegocieJaFormaPagamento">
                  <td>{{item.nome }}</td>
                  <td class="actions">
                    <a href="#" @click.prevent="editarFormaPagamento(item)">
                      <fa :icon="['fal','pencil']" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </main>
    </controller>
    <novo-pagamento
      v-if="mostrarModalNovoPagamento"
      :forma-para-editar="formaParaEditar"
      @fechar="fecharModalNovoPagamento"
    />

</template>

<script>
import Controller from '@/components/template/Controller.vue'
// import negociejaService from '@/services/negocieja.service.js'
import NovoPagamento from '@/components/financeiro/negocieja/pagamentos/NovoPagamento.vue';
import NegociaService from '@/services/negocieja.service.js'

export default {
  components: { Controller, NovoPagamento },
  name: 'FormasPagamento',
  emits: ['fechar'],
  data() {
    return {
      mostrarModalNovoPagamento: false,
      formasPagamento: [],
      formaParaEditar: null,
    }
  },
mounted() {
  this.getPagamentos()
},
  methods: {
    getPagamentos () {
      NegociaService.getPagamentos().then(
        response => {
          this.formasPagamento = response.data
        },
        error => {
          console.error('Erro ao buscar formas de pagamento:', error)
        }
      );
    },
    abrirModalNovoPagamento (i) { 
      this.mostrarModalNovoPagamento = true 
      this.modalActive = i
    },
    editarFormaPagamento(item) {
      this.formaParaEditar = {
        forma: item,
        entrada: item.entrada[0] ?? {},
        parcelas: item.parcelas[0] ?? {}
      }
      this.mostrarModalNovoPagamento = true
    },
    fecharModalNovoPagamento () { 
      this.mostrarModalNovoPagamento = false
      this.formaParaEditar = null
      this.getPagamentos()


      this.$nextTick(() => {
        this.modalActive = null
      })
    },

  }
};
</script>

<style lang="scss" scoped>

.main-page{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.table-body{
  width: 100%;
  padding: $hmg_mid;
  display: flex;
  justify-content: center;
}

.transparent-table {
  width: 80%;

  td {
    border-radius: 0 !important;
    &:first-child {
      border-bottom-left-radius: none !important
    }
    &:last-child {
      border-bottom-right-radius: none !important
    }
  }
}

.transparent-table th,
.transparent-table td {
  padding: 0.75rem;
  border-bottom: $border_component;
  text-align: left;
}

.actions {
  display: flex;
  font-size: 18px;
  justify-content: center;
  align-items: center;
  text-align: center !important;
}

.header-page{
    flex-direction: column;
    display: flex;
    justify-content: center;
    width: 80%;
    padding: $hmg-mid;
    gap: 1rem;

    .input-control{
      width: 35%;
    }
}

</style>